import { useBack } from "@website/hooks/back";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui-old/button";
import throttle from "lodash-es/throttle";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";

export const useHeaderWrapper = () => {
  const [scrolled, setScrolled] = useState<boolean>(false);
  const router = useRouter();
  const { goBack } = useBack();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    const onScrollThrottle = throttle(onScroll, 100);

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", onScrollThrottle);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", onScrollThrottle);
      }
    };
  }, []);

  const title = useMemo(() => {
    switch (router.pathname) {
      case "/": {
        return "حساب کاربری";
      }
      case "/information": {
        return "اطلاعات کاربر";
      }
      case "/wallet": {
        return "کیف پول";
      }
      case "/passengers-list": {
        return "لیست مسافران";
      }
    }
    return "";
  }, [router.pathname]);

  return {
    scrolled,
    headerProperties: {
      showAuth: true,
      showBackButton: false,
      minimalView: false
    },
    topAppBarProperties: {
      StartAction: (
        <Button
          EndIcon={<MaterialIcon name="arrow_forward" />}
          color="neutral"
          equalDimension
          onClick={goBack}
          variant="text"
        />
      ),
      title
    }
  };
};
